import { graphql, useStaticQuery } from 'gatsby';

interface KfhBuildInfoProps {
  lastBuild: Date;
}

export const UseBuildInfo = (): KfhBuildInfoProps => {
  const { kfhBuildInfo } = useStaticQuery(
    graphql`
      query BUILD_INFO {
        kfhBuildInfo {
          lastBuild
        }
      }
    `
  );
  return kfhBuildInfo;
};
